function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { requiredValidation } from 'validators';
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField, Typography } from 'seagull';
import { useGlobalContext, useIoContext, useStoreActions } from "../../contexts";
import ExternalLinkButton from "../ExternalLinkButton";
import { ErrorText } from "../../constants";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { getHelpArticle, handlePromise } from "../../infra/utils";
import styles from "./RequestRefund.module.scss";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
const DisabledTextField = props => /*#__PURE__*/React.createElement(TextField, _extends({
  width: '45%',
  disabled: true
}, props));
const statusMap = {
  paid: 'Paid',
  paymentConfirmed: 'Collected',
  processingCharge: 'Processing'
};
const RequestRefund = _ref => {
  let {
    vendor: {
      fullName,
      companyName,
      businessID,
      sellerID
    },
    customer,
    status,
    issuedOn,
    invoiceID,
    totalAmount,
    paymentMethod,
    relationshipID,
    formattedNumber,
    dismissModal,
    onSuccess
  } = _ref;
  const {
    REFUND_AUTOMATION
  } = useFeatureFlags();
  const {
    api
  } = useStoreActions();
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all'
  });
  const {
    slackClient: {
      sendCsNotificationsMessage
    }
  } = useIoContext();
  const globalContext = useGlobalContext();
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Request a refund",
    "data-testid": "request-refund-modal",
    primaryButtonLabel: "Submit request",
    secondaryButtonLabel: "Cancel",
    onPrimaryButtonClick: handleSubmit(async _ref2 => {
      let {
        reason
      } = _ref2;
      globalContext.startLoader();
      const {
        success
      } = await (REFUND_AUTOMATION ? handlePromise(api.invoice.refundPayment(invoiceID, reason)) : sendCsNotificationsMessage("Refund requested by ".concat(fullName, " from ").concat(companyName, " \uD83D\uDCB8\nRefunding Business ID - ").concat(businessID, "\nRefunding Business Name - ").concat(companyName, "\nRefunding User ID - ").concat(sellerID, "\nRefunding User Name - ").concat(fullName, "\nRefunded Business ID - ").concat(customer.id, "\nRefunded Business Name - ").concat(customer.name, "\nInvoice ID - ").concat(invoiceID, "\nInvoice Number - ").concat(formattedNumber, "\nRelationship ID - ").concat(relationshipID, "\nTotal Amount - ").concat(totalAmount, "\nPayment Method - ").concat(paymentMethod, "\nPayment Status - ").concat(statusMap[status], "\n***\nReason - \"").concat(reason, "\"\n")));
      if (!success) {
        globalContext.showErrorToast(ErrorText.UnexpectedErrorTryAgain, 'request-refund-error-toast');
      } else {
        REFUND_AUTOMATION && onSuccess(reason);
        dismissModal();
        globalContext.showSuccessToast('Refund request submitted', 'request-refund-success-toast');
      }
      globalContext.stopLoader();
    }),
    onSecondaryButtonClick: dismissModal,
    primaryButtonTestid: "request-refund-submit",
    secondaryButtonTestid: "request-refund-cancel",
    width: "640",
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.fieldsContainer
    }, /*#__PURE__*/React.createElement(DisabledTextField, {
      "data-testid": "request-refund-client-name",
      value: customer.name,
      label: "Client name"
    }), /*#__PURE__*/React.createElement(DisabledTextField, {
      "data-testid": "request-refund-invoice-number",
      value: formattedNumber,
      label: "Invoice number"
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.fieldsContainer
    }, /*#__PURE__*/React.createElement(DisabledTextField, {
      "data-testid": "request-refund-issued-on",
      value: issuedOn,
      label: "Issue date"
    }), /*#__PURE__*/React.createElement(DisabledTextField, {
      "data-testid": "request-refund-total-amount",
      value: totalAmount,
      label: "Amount"
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.reasonContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      weight: "bold",
      variant: "h6"
    }, "What's the reason for this refund?"), /*#__PURE__*/React.createElement(Typography, null, "This is internal and will not show up for your client"), /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "reason",
      rules: requiredValidation('Please provide a reason'),
      render: props => /*#__PURE__*/React.createElement("div", {
        className: styles.inputField
      }, /*#__PURE__*/React.createElement(TextField, _extends({
        multiline: true,
        autoFocus: true,
        minRows: 2,
        maxRows: 3
      }, connectControllerToTextField(props), {
        "data-testid": "request-refund-reason-field"
      })))
    }), /*#__PURE__*/React.createElement(Typography, {
      className: styles.infoParagraph
    }, "Refunds are deducted from future payouts when possible. If not, funds will be withdrawn from your account to cover the balance. Refunds may take 5-10 business days to appear in the customer's bank account, and fees may apply."), /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      href: getHelpArticle('8011138-refunding-client-payments')
    }, "Learn more about refunds")))
  });
};
export default RequestRefund;